class AuxiliaresGlobal {
  static obtenerSucursalTrabajo(informacion) {
    const coordenadasInfo = {
      lat: parseFloat(informacion.lat),
      lng: parseFloat(informacion.lng),
    };

    let sucursalMasCercana = null;
    let distanciaMinima = Infinity;
    let diferenciasSucursales = [];

    // Encontrar la sucursal más cercana
    for (let i = 0; i < window.sucursales.length; i++) {
      const sucursal = window.sucursales[i];

      const coordenadasSucursal = {
        lat: parseFloat(sucursal.lat),
        lng: parseFloat(sucursal.lng),
      };

      const distancia = this.calcularDistanciaEuclidiana(
        coordenadasInfo,
        coordenadasSucursal
      );

      diferenciasSucursales.push({
        nombre: sucursal.nombre || sucursal.id || `Sucursal ${i + 1}`,
        distancia: distancia,
      });

      if (distancia < distanciaMinima) {
        distanciaMinima = distancia;
        sucursalMasCercana = { ...sucursal, distancia };
      }
    }

    // Mostrar en consola la sucursal ganadora
    console.log("📊 Diferencias de distancia (Euclidiana):");
    diferenciasSucursales
      .sort((a, b) => a.distancia - b.distancia)
      .forEach((suc, index) => {
        const emoji = index === 0 ? "🏆" : "  ";
        console.log(`${emoji} ${suc.nombre}: ${suc.distancia.toFixed(2)} km`);
      });

    return sucursalMasCercana;
  }

  static calcularDistanciaEuclidiana(coordenadas1, coordenadas2) {
    const dLat = coordenadas2.lat - coordenadas1.lat;
    const dLng = coordenadas2.lng - coordenadas1.lng;

    // Convertir diferencias a kilómetros
    const latKm = dLat * 111.32; // 1° latitud = 111.32 km (constante)
    const lngKm = dLng * 111.32 * Math.cos((coordenadas1.lat * Math.PI) / 180);

    // DISTANCIA EUCLIDIANA (Teorema de Pitágoras)
    const distancia = Math.sqrt(latKm * latKm + lngKm * lngKm);

    console.log(
      `📐 Cálculo: √(${latKm.toFixed(2)}² + ${lngKm.toFixed(
        2
      )}²) = ${distancia.toFixed(2)} km`
    );

    return distancia;
  }

  // Muestra un mensaje de éxito para el carrito
  static mensajeExitoCarrito() {
    MensajeTemporal.mostrarMensaje(
      "Se añadió tu orden al carrito con éxito.",
      "exito"
    );
  }

  /**
   * Muestra un mensaje de error
   * @param {string} mensaje - Mensaje de error a mostrar
   */
  static mensajeError(mensaje = "Ha ocurrido un error.") {
    MensajeTemporal.mostrarMensaje(mensaje, "error");
  }

  /**
   * Muestra un mensaje informativo
   * @param {string} mensaje - Mensaje informativo a mostrar
   */
  static mensajeInfo(mensaje = "Información importante.") {
    MensajeTemporal.mostrarMensaje(mensaje, "info");
  }

  /**
   * Muestra un mensaje de alerta
   * @param {string} mensaje - Mensaje de alerta a mostrar
   */
  static mensajeAlerta(mensaje = "Advertencia.") {
    MensajeTemporal.mostrarMensaje(mensaje, "alerta");
  }

  // MÉTODOS PARA OBTENER INFORMACIÓN DEL CARRITO (BACKEND SHOPIFY)
  static obtenerCarritoShopify() {
    return new Promise((resolve, reject) => {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          // Mostrar en consola la información completa del carrito
          // console.log('Información completa del carrito Shopify:', cart);

          // Crear un objeto con la información solicitada
          const infoCarrito = {
            informacionCompleta: cart, // Todo el objeto original del carrito
            cantidadTotal: cart.item_count, // Solo la cantidad total de productos
          };

          // Mostrar en consola específicamente la cantidad total
          // console.log(`Cantidad total de productos: ${infoCarrito.cantidadTotal}`);

          resolve(infoCarrito);
        })
        .catch((error) => {
          console.error("Error al obtener el carrito de Shopify:", error);
          reject(error);
        });
    });
  }

  static totalPrecioCarritoShopify() {
    return new Promise((resolve, reject) => {
      // Utilizar la función existente para obtener el carrito
      this.obtenerCarritoShopify()
        .then((carrito) => {
          // Verificar que existe la información y el precio total
          if (
            carrito &&
            carrito.informacionCompleta &&
            typeof carrito.informacionCompleta.total_price !== "undefined"
          ) {
            // Obtener el precio total (viene en centavos)
            const precioTotalCentavos = carrito.informacionCompleta.total_price;

            // Convertir a formato de moneda (dividir por 100 para obtener el valor en la moneda base)
            const precioTotal = precioTotalCentavos / 100;

            // Mostrar en consola el precio total formateado
            console.log(`Precio total del carrito: ${precioTotal.toFixed(2)}`);

            // Resolver la promesa con el precio total
            resolve(precioTotal);
          } else {
            throw new Error("No se pudo obtener el precio total del carrito");
          }
        })
        .catch((error) => {
          console.error(
            "Error al calcular el precio total del carrito:",
            error
          );
          reject(error);
        });
    });
  }

  static cantidadProductosCarritoShopify() {
    return new Promise((resolve, reject) => {
      // Utilizar la función existente para obtener el carrito
      this.obtenerCarritoShopify()
        .then((carrito) => {
          // Verificar que existe la información del carrito
          if (carrito && typeof carrito.cantidadTotal !== "undefined") {
            // Obtener la cantidad total de productos
            const cantidadTotal = carrito.cantidadTotal;

            // Mostrar en consola la cantidad total de productos
            console.log(
              `Cantidad total de productos en el carrito: ${cantidadTotal}`
            );

            // Resolver la promesa con la cantidad total
            resolve(cantidadTotal);
          } else {
            throw new Error(
              "No se pudo obtener la cantidad de productos del carrito"
            );
          }
        })
        .catch((error) => {
          console.error(
            "Error al obtener la cantidad de productos del carrito:",
            error
          );
          reject(error);
        });
    });
  }

  /**
   * Actualiza un ítem en el carrito
   * @param {string} key - Key del ítem a eliminar
   * @param {number} variante - ID de la variante para el nuevo ítem
   * @param {number} cantidad - Cantidad del nuevo ítem
   * @param {Object} propiedades - Propiedades del nuevo ítem
   * @returns {Promise} - Carrito actualizado
   */
  static actualizarItemCarrito(key, variante, cantidad, propiedades = {}) {
    return new Promise((resolve, reject) => {
      // 1. Eliminar el ítem existente
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 }),
      })
        .then((response) => response.json())
        .then(() => {
          console.log(
            "URL TRABAJO SHOPIFY: ",
            window.urlTrabajoShopify + "cart/add.js"
          );
          // 2. Agregar la nueva variante con cantidad y propiedades
          return fetch(window.urlTrabajoShopify + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
              items: [
                {
                  id: variante,
                  quantity: cantidad,
                  properties: propiedades,
                },
              ],
            }),
          });
        })
        .then(async (response) => {
          if (!response.ok) {
            const text = await response.text();
            const isAgotado =
              text.toLowerCase().includes("agotado") ||
              text.toLowerCase().includes("sold out");
            if (response.status === 422 || isAgotado) {
              console.warn(
                "⚠️ Producto agotado o error 422, limpiando carrito..."
              );
              await fetch("/cart/clear.js", { method: "POST" });
              throw new Error("Producto agotado o inválido (422)");
            }
            throw new Error(`Error HTTP ${response.status}`);
          }
          return response.json();
        })
        .then(() => fetch("/cart.js"))
        .then((response) => response.json())
        .then((carrito) => {
          this.sincronizarContadorConCarrito(carrito);
          resolve(carrito);
        })
        .catch((error) => {
          console.error("❌ Error al actualizar ítem del carrito:", error);
          reject(error);
        });
    });
  }

  /**
   * Método para actualizar el contador visual
   */
  static actualizarContadorVisual(valor) {
    const contenedoresPadre = document.querySelectorAll(".h-ic-cantidad");
    const mensajes = document.querySelectorAll(".hicc-mensaje");

    // Verificar que haya elementos
    if (mensajes && mensajes.length > 0) {
      // Iterar sobre cada mensaje encontrado
      mensajes.forEach((mensaje) => {
        // Obtener el valor actual (si existe)
        let valorActual = 0;
        if (mensaje.textContent.trim() !== "") {
          valorActual = parseInt(mensaje.textContent, 10) || 0;
        }

        // Sumar el nuevo valor al actual
        const nuevoValor = valorActual + valor;

        // Actualizar el texto con el nuevo valor
        mensaje.textContent = nuevoValor;

        // Quitar clases existentes de tamaños de dígitos
        mensaje.classList.remove("digitos-2", "digitos-3");

        // Convertir el valor a string para verificar su longitud
        const valorStr = nuevoValor.toString();

        if (nuevoValor == 0) {
          console.log("El carrito está vacío, ocultando contenedores");
          contenedoresPadre.forEach((contenedor) => {
            contenedor.style.display = "none";
          });
        } else {
          contenedoresPadre.forEach((contenedor) => {
            contenedor.style.display = "flex";
          });
        }

        // Añadir clase según número de dígitos
        if (valorStr.length === 2) {
          mensaje.classList.add("digitos-2");
        } else if (valorStr.length >= 3) {
          mensaje.classList.add("digitos-3");
        }
      });

      // Mostrar mensaje de éxito después de actualizar todos los carritos
      this.mensajeExitoCarrito();

      // Actualizar también todos los componentes CarritoShopify
      // this.actualizarComponentesCarrito();
    }
  }

  /**
   * Actualiza todos los componentes CarritoShopify en la página
   */
  static actualizarComponentesCarrito() {
    // Si existe el método estático en CarritoShopify, usarlo
    if (
      typeof CarritoShopify !== "undefined" &&
      typeof CarritoShopify.actualizarContador === "function"
    ) {
      CarritoShopify.actualizarContador();
    } else {
      // Si no, buscar todos los componentes y actualizar manualmente
      const componentesCarrito = document.querySelectorAll("carrito-shopify");
      componentesCarrito.forEach((componente) => {
        if (typeof componente.actualizarContadorCarrito === "function") {
          componente.actualizarContadorCarrito();
        }
      });
    }
  }

  /**
   * Limpia el carrito (lo vacía por completo)
   */
  static limpiarCarrito() {
    return new Promise((resolve, reject) => {
      // Usar la API de Shopify para vaciar el carrito
      fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // Actualizar el contador visual a 0
          const mensaje = document.querySelector(".hicc-mensaje");
          if (mensaje) {
            mensaje.textContent = "0";
            mensaje.classList.remove("digitos-2", "digitos-3");
          }

          // Actualizar los componentes CarritoShopify
          this.actualizarComponentesCarrito();

          // Mostrar mensaje de éxito
          // this.mensajeInfo('El carrito ha sido vaciado');

          // Disparar evento personalizado
          document.dispatchEvent(new CustomEvent("cart:cleared"));

          console.log("Carrito limpiado:", data);
          resolve(data);
        })
        .catch((error) => {
          console.error("Error al limpiar el carrito:", error);
          this.mensajeError("No se pudo vaciar el carrito");
          reject(error);
        });
    });
  }

  /**
   * Elimina un ítem específico del carrito usando su key
   * @param {string} key - Key única del ítem a eliminar
   * @param {number} quantity - Nueva cantidad (0 para eliminar)
   */
  static eliminarItemCarritoPorKey(key, quantity) {
    return new Promise((resolve, reject) => {
      // Usar la API de Shopify para actualizar el carrito
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: key, // Usamos la key como id
          quantity: quantity, // 0 para eliminar, otro valor para actualizar
        }),
      })
        .then((response) => response.json())
        .then((cart) => {
          // Actualizar el contador visual y componentes
          this.sincronizarContadorConCarrito(cart);

          // Mostrar mensaje de éxito
          // const mensaje = quantity === 0 ? 'Producto eliminado del carrito' : 'Carrito actualizado';
          // this.mensajeInfo(mensaje);

          // Disparar evento personalizado
          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: { cart },
            })
          );

          // console.log('Carrito actualizado:', cart);
          resolve(cart);
        })
        .catch((error) => {
          console.error("Error al actualizar el carrito:", error);
          this.mensajeError("No se pudo actualizar el carrito");
          reject(error);
        });
    });
  }

  /**
   * Actualiza la cantidad de un ítem en el carrito usando su key
   * @param {string} key - Key única del ítem a actualizar
   * @param {number} cantidad - Nueva cantidad
   */
  static actualizarCantidadItemPorKey(key, cantidad) {
    return new Promise((resolve, reject) => {
      // Validar cantidad
      if (typeof cantidad !== "number" || cantidad < 0) {
        reject(new Error("Cantidad inválida"));
        return;
      }

      // Usar la API de Shopify para actualizar el carrito
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: key, // Usamos key en lugar de line
          quantity: cantidad,
        }),
      })
        .then((response) => response.json())
        .then((cart) => {
          // Actualizar el contador visual y componentes
          this.sincronizarContadorConCarrito(cart);

          // Mostrar mensaje de éxito
          this.mensajeInfo("Carrito actualizado");

          // Disparar evento personalizado
          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: { cart },
            })
          );

          console.log("Carrito actualizado:", cart);
          resolve(cart);
        })
        .catch((error) => {
          console.error("Error al actualizar el carrito:", error);
          this.mensajeError("No se pudo actualizar el carrito");
          reject(error);
        });
    });
  }

  /**
   * Sincroniza el contador visual con el estado actual del carritoo
   * @param {Object} cart - Objeto carrito devuelto por Shopify
   */
  static sincronizarContadorConCarrito(cart) {
    const mensajes = document.querySelectorAll(".hicc-mensaje");
    const contenedorPadre = document.querySelectorAll(".h-ic-cantidad");
    if (mensajes && mensajes.length > 0) {
      const cantidadTotal = cart.item_count || 0;

      // Actualizar todos los elementos de mensaje encontrados
      mensajes.forEach((mensaje) => {
        mensaje.textContent = cantidadTotal;

        if (cantidadTotal == 0) {
          // Si la cantidad total es 0, ocultar los contenedores
          contenedorPadre.forEach((contenedor) => {
            contenedor.style.display = "none";
          });
        } else {
          // Si hay productos, mostrar los contenedores
          contenedorPadre.forEach((contenedor) => {
            contenedor.style.display = "flex";
          });
        }

        // Actualizar clases
        mensaje.classList.remove("digitos-2", "digitos-3");
        const valorStr = cantidadTotal.toString();
        if (valorStr.length === 2) {
          mensaje.classList.add("digitos-2");
        } else if (valorStr.length >= 3) {
          mensaje.classList.add("digitos-3");
        }
      });

      console.log("Cantidad total de productos Testeo:", cantidadTotal);
    }

    // Actualizar componentes CarritoShopify
    this.actualizarComponentesCarrito();
  }

  // MÉTODOS DE GOOGLE MAPS
  static obtenerDireccionDesdeCoordenadas(lat, lng) {
    return new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      const latlng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      };

      geocoder.geocode(
        {
          location: latlng,
          language: "es", // Resultados en español
        },
        (results, status) => {
          if (status === "OK" && results && results.length > 0) {
            // Intentar extraer la información más útil para delivery
            let direccionFinal = "";
            let calleEncontrada = false;

            // Primero buscar el resultado que tenga más detalles de calle
            for (const result of results) {
              // Verificar si este resultado tiene componentes de dirección útiles
              const tieneRuta = result.address_components.some(
                (comp) =>
                  comp.types.includes("route") ||
                  comp.types.includes("street_address")
              );

              if (tieneRuta) {
                direccionFinal = result.formatted_address;
                calleEncontrada = true;
                break;
              }
            }

            // Si no se encontró información de calle, usar la dirección más detallada disponible
            if (!calleEncontrada) {
              direccionFinal = results[0].formatted_address;
            }

            // Eliminar el código plus (si existe) de la dirección final
            direccionFinal = direccionFinal
              .replace(/\b[0-9A-Z]{4}\+[0-9A-Z]{2,3}\b,?/g, "")
              .trim();

            // Eliminar el país si está al final para hacerlo más conciso
            const paisRegex = /, Bolivia$/;
            if (paisRegex.test(direccionFinal)) {
              direccionFinal = direccionFinal.replace(paisRegex, "");
            }

            resolve(direccionFinal || "Dirección no disponible");
          } else {
            reject("No se pudo obtener una dirección detallada: " + status);
          }
        }
      );
    });
  }

  static obtenerPlusCodeDesdeCoordenadas(lat, lng) {
    return new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      const latlng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      };

      geocoder.geocode(
        {
          location: latlng,
          language: "es",
        },
        (results, status) => {
          if (status === "OK" && results && results.length > 0) {
            let plusCode = null;

            // Buscar en todos los resultados el Plus Code
            for (const result of results) {
              // Verificar si hay Plus Code en el resultado (formato oficial de Google)
              if (result.plus_code) {
                // Preferir compound_code si existe (ej: "57RG+2H Santa Cruz")
                if (result.plus_code.compound_code) {
                  plusCode = result.plus_code.compound_code;
                  break;
                }
                // Si no, usar global_code (ej: "588G57RG+2H")
                else if (result.plus_code.global_code) {
                  plusCode = result.plus_code.global_code;
                  break;
                }
              }

              // También buscar en la dirección formateada usando regex más preciso
              const plusCodeMatch = result.formatted_address.match(
                /\b([0-9A-Z]{4}\+[0-9A-Z]{2,3}(?:\s+[^,]+)?)\b/
              );
              if (plusCodeMatch) {
                plusCode = plusCodeMatch[1];
                break;
              }
            }

            if (plusCode) {
              resolve(plusCode);
            } else {
              reject("No se encontró Plus Code para estas coordenadas");
            }
          } else {
            reject("Error en la geocodificación: " + status);
          }
        }
      );
    });
  }

  // Función alternativa que devuelve tanto la dirección como el Plus Code
  static obtenerDireccionShopify(lat, lng) {
    return new Promise((resolve, reject) => {
      // Validación inicial de coordenadas
      if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
        reject("Coordenadas inválidas");
        return;
      }

      const geocoder = new google.maps.Geocoder();
      const latlng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      };

      console.log(`🔍 Geocodificando: ${lat}, ${lng}`);

      geocoder.geocode(
        {
          location: latlng,
          language: "es",
        },
        (results, status) => {
          if (status === "OK" && results && results.length > 0) {
            // Tomar el primer resultado y usar su formatted_address directamente
            const primerResultado = results[0];
            const direccionCompleta = primerResultado.formatted_address;

            console.log(`📍 Dirección obtenida: ${direccionCompleta}`);

            // Extraer solo la ciudad y departamento de los componentes
            let ciudad = "Santa Cruz de la Sierra";
            let departamento = "Santa Cruz";

            const componentes = primerResultado.address_components;
            componentes.forEach((componente) => {
              const tipos = componente.types;

              // Ciudad
              if (
                tipos.includes("locality") ||
                tipos.includes("administrative_area_level_2")
              ) {
                ciudad = componente.long_name;
              }

              // Departamento
              if (tipos.includes("administrative_area_level_1")) {
                departamento = componente.long_name;
              }
            });

            // Mapear códigos de departamentos de Bolivia
            const departamentosCodigos = {
              "La Paz": "LP",
              Cochabamba: "CB",
              "Santa Cruz": "SC",
              Oruro: "OR",
              Potosí: "PT",
              Tarija: "TJ",
              Sucre: "SU",
              Chuquisaca: "CH",
              Beni: "BN",
              Pando: "PD",
            };

            const codigoDepartamento =
              departamentosCodigos[departamento] || "SC";

            // Formato Shopify final - SIMPLE
            const direccionShopify = {
              address1: direccionCompleta,
              address2: "",
              city: "Santa Cruz de la Sierra",
              province: "Santa Cruz",
              provinceCode: codigoDepartamento,
              country: "Bolivia",
              countryCode: "BO",
              zip: "0000",
            };

            console.log("🎯 Resultado final:", direccionShopify);
            resolve(direccionShopify);
          } else {
            console.error(`❌ Error en geocodificación: ${status}`);
            reject(`Error en la geocodificación: ${status}`);
          }
        }
      );
    });
  }

  // ALTERNATIVA: Función que devuelve Plus Code por separado si lo necesitas
  static async obtenerDireccionConPlusCode(lat, lng) {
    try {
      const direccionShopify = await this.obtenerDireccionShopify(lat, lng);

      // Obtener Plus Code por separado
      const geocoder = new google.maps.Geocoder();
      const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

      return new Promise((resolve) => {
        geocoder.geocode({ location: latlng }, (results, status) => {
          let plusCode = null;

          if (status === "OK" && results && results.length > 0) {
            const resultado = results[0];
            if (resultado.plus_code) {
              plusCode =
                resultado.plus_code.compound_code ||
                resultado.plus_code.global_code;
            }
          }

          resolve({
            direccionShopify,
            plusCode,
            coordenadas: { lat, lng },
          });
        });
      });
    } catch (error) {
      throw error;
    }
  }

  // Función auxiliar para testing
  static async testearDireccionShopify(lat, lng, descripcion = "") {
    try {
      console.log(`\n🧪 === TESTING: ${descripcion} ===`);
      console.log(`📍 Coordenadas: ${lat}, ${lng}`);

      const resultado = await this.obtenerDireccionShopify(lat, lng);

      console.log("✅ Resultado Shopify:");
      console.log(JSON.stringify(resultado, null, 2));

      return resultado;
    } catch (error) {
      console.error("❌ Error:", error);
      return null;
    }
  }

  /**
   * Agrega productos al carrito y actualiza la visualización
   * @param {number} valor - Cantidad de productos a agregarobtenerStockYEstadoProducto
   * @param {number} variantId - ID de la variante del producto (opcional)
   * @param {Object} opciones - Opciones adicionales para el producto (opcional)
   */
  static agregarCarrito(valor, variantId = null, opciones = {}) {
    if (typeof valor === "number" && valor > 0) {
      if (variantId) {
        const datos = {
          items: [
            {
              id: variantId,
              quantity: valor,
              ...opciones,
            },
          ],
        };

        // console.log('🔍 DATOS ENVIADOS:', JSON.stringify(datos, null, 2));

        fetch(window.urlTrabajoShopify + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(datos),
        })
          .then((response) => {
            // console.log('🔍 RESPUESTA COMPLETA:', response);
            if (!response.ok) {
              throw new Error(
                `HTTP error! status: ${response.status} - ${response.statusText}`
              );
            }
            return response.json();
          })
          .then((data) => {
            if (data.status || data.message || data.error || data.errors) {
              // console.error('❌ ERROR EN DATOS DEL SERVIDOR:', data);
              let mensajeError =
                data.message || "No se pudo agregar el producto al carrito";

              if (
                data.status === 422 ||
                (data.message && data.message.toLowerCase().includes("agotado"))
              ) {
                mensajeError = "Este producto está agotado";
                // 🔥 Limpieza de carrito para resolver posible corrupción
                fetch("/cart/clear.js", { method: "POST" })
                  .then(() =>
                    console.warn("🧹 Carrito limpiado tras error 422/agotado")
                  )
                  .catch((err) =>
                    console.error("⚠️ Error al limpiar carrito:", err)
                  );
              }

              this.mensajeError(mensajeError);
              return;
            }

            // console.log('✅ ÉXITO - Producto agregado al carrito:', data);
            this.actualizarContadorVisual(valor);
            document.dispatchEvent(
              new CustomEvent("product:added-to-cart", {
                detail: { product: data },
              })
            );
          })
          .catch((error) => {
            // console.error('❌ ERROR EN CATCH:', error);

            let mensajeError = "No se pudo agregar el producto al carrito";
            const msg = error.message.toLowerCase();

            if (msg.includes("422")) {
              mensajeError = "Datos del producto inválidos (422)";
              fetch("/cart/clear.js", { method: "POST" })
                .then(() =>
                  console.warn("🧹 Carrito limpiado tras error 422 en catch")
                )
                .catch((err) =>
                  console.error("⚠️ Error al limpiar carrito en catch:", err)
                );
            }

            this.mensajeError(mensajeError);
          });
      } else {
        // console.log('⚠️ No se proporcionó variantId, solo actualizando contador visual');
        this.actualizarContadorVisual(valor);
      }
    } else {
      console.error("❌ VALOR INVÁLIDO:", valor);
    }
  }

  static agregarMultiplesProductosCarrito(productos) {
    if (!Array.isArray(productos) || productos.length === 0) {
      console.error("Se requiere un array de productos válido");
      this.mensajeError("No se proporcionaron productos válidos");
      return Promise.reject("Array de productos inválido");
    }

    const datos = {
      items: productos.map((producto) => {
        const item = {
          id: parseInt(producto.varianteId),
          quantity: parseInt(producto.cantidad),
        };
        if (
          producto.properties &&
          Object.keys(producto.properties).length > 0
        ) {
          item.properties = producto.properties;
        }
        return item;
      }),
    };

    return fetch(window.urlTrabajoShopify + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(datos),
    })
      .then(async (response) => {
        console.log("Respuesta HTTP recibida:", response);
        if (!response.ok) {
          const text = await response.text();
          const isAgotado =
            text.toLowerCase().includes("agotado") ||
            text.toLowerCase().includes("sold out");
          if (response.status === 422 || isAgotado) {
            await fetch("/cart/clear.js", { method: "POST" });
            console.warn(
              "🧹 Carrito limpiado tras error 422 o producto agotado"
            );
            throw new Error(
              "Uno o más productos están agotados o no son válidos (422)"
            );
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("Productos agregados al carrito exitosamente:", data);

        const totalProductosAgregados = productos.reduce((total, producto) => {
          return total + (parseInt(producto.cantidad) || 1);
        }, 0);

        this.actualizarContadorVisual(totalProductosAgregados);

        document.dispatchEvent(
          new CustomEvent("product:added-to-cart", {
            detail: {
              products: data,
              totalItems: totalProductosAgregados,
              originalProducts: productos,
            },
          })
        );

        console.log("✅ Proceso completado exitosamente");
        return data;
      })
      .catch((error) => {
        console.error("❌ Error al agregar productos al carrito:", error);
        const mensajeError =
          error.message || "No se pudieron agregar los productos al carrito";
        this.mensajeError(mensajeError);
        throw error;
      });
  }

  static eliminarMultiplesProductos(productos) {
    return new Promise((resolve, reject) => {
      // Validar que productos sea un array y tenga al menos un elemento
      if (!Array.isArray(productos) || productos.length === 0) {
        reject(new Error("Debe proporcionar un array de productos válido"));
        return;
      }

      // Preparar objeto updates con todas las keys
      const updates = {};

      productos.forEach((producto) => {
        if (typeof producto === "string") {
          // Si es string, es la key
          updates[producto] = 0;
        } else if (producto.key) {
          // Si es objeto con key
          updates[producto.key] = producto.quantity || 0;
        }
      });

      // Una sola petición para actualizar múltiples productos
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      })
        .then((response) => response.json())
        .then((cart) => {
          // Actualizar componentes una sola vez
          this.sincronizarContadorConCarrito(cart);

          // Disparar evento personalizado
          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: { cart },
            })
          );

          console.log("Múltiples productos eliminados en una petición:", cart);
          resolve(cart);
        })
        .catch((error) => {
          console.error("Error al eliminar múltiples productos:", error);
          this.mensajeError(
            "No se pudieron eliminar los productos del carrito"
          );
          reject(error);
        });
    });
  }
}

class CarritoShopify extends HTMLElement {
  constructor() {
    super();
    // Inicializar variable para almacenar la cantidad
    this.cantidadTotal = 0;
  }

  connectedCallback() {
    // Obtener el contador
    const contador = this.querySelector("#contador-carrito");

    // Usar AuxiliaresGlobal para obtener la cantidad actual del carrito de Shopify
    AuxiliaresGlobal.obtenerCarritoShopify()
      .then((carrito) => {
        // Guardar la cantidad en la propiedad de la clase
        this.cantidadTotal = carrito.cantidadTotal || 0;

        // Actualizar el texto del contador con la cantidad actual
        if (contador) {
          contador.textContent = this.cantidadTotal;
        }

        if (this.cantidadTotal !== 0) {
          this.contenedorPadre = this.querySelector(".h-ic-cantidad");
          this.contenedorPadre.style.display = "flex ";
        }

        // Log después de obtener los datos
        // console.log('Componente CarritoShopify inicializado');
        // console.log('Cantidad total de productos:', this.cantidadTotal);
      })
      .catch((error) => {
        console.error("Error al obtener el carrito:", error);
      });
  }
}

customElements.define("carrito-shopify", CarritoShopify);

class CantidadInput extends HTMLElement {
  constructor() {
    super();

    this.btn = this.querySelectorAll("button");
    this.contenedorGeneral = this.querySelector("div");
    this.parrafo = this.querySelector("p");
    this.baseTrabajo = null;
    this.min = null;
    this.max = null;
  }

  // Propiedad calculada que siempre lee el valor actual del DOM
  get cantidadEtiqueta() {
    return parseInt(this.parrafo.textContent) || 0;
  }

  // Setter que actualiza tanto la variable como el DOM
  set cantidadEtiqueta(valor) {
    this.parrafo.textContent = valor;
    this.actualizarBotones();
  }

  connectedCallback() {
    this.inicializarElemento();
    this.actualizarBotones(); // Inicializar estado de botones

    this.btn.forEach((boton) => {
      boton.addEventListener(
        "click",
        this.manejarAccionBoton.bind(this, boton)
      );
    });
  }

  inicializarElemento() {
    this.baseTrabajo =
      this.contenedorGeneral.getAttribute("origen-trabajo") || "no-definido";
    this.min = parseInt(this.contenedorGeneral.getAttribute("min")) || 0;
    this.max = parseInt(this.contenedorGeneral.getAttribute("max")) || 100;
    this.idProducto =
      this.contenedorGeneral.getAttribute("id-producto") || "no-definido";
    this.handle =
      this.contenedorGeneral.getAttribute("handle") || "no-definido";

    if (this.baseTrabajo != "carrito") {
      this.btn[1].classList.remove("elemento-oculto");
    }
  }

  actualizarBotones() {
    // Actualizar visibilidad de botones según el valor actual
    const cantidad = this.cantidadEtiqueta;

    if (this.baseTrabajo == "carrito") {
      if (cantidad <= 1) {
        this.btn[0].classList.remove("elemento-oculto");
        this.btn[1].classList.add("elemento-oculto");
      } else {
        this.btn[0].classList.add("elemento-oculto");
        this.btn[1].classList.remove("elemento-oculto");
      }
    }
  }

  manejarAccionBoton(boton) {
    const accion = boton.getAttribute("accion");
    let nuevaCantidad = this.cantidadEtiqueta;

    if (accion == "incrementar" && nuevaCantidad < this.max) {
      nuevaCantidad++;
      this.parrafo.textContent = nuevaCantidad;
    }

    if (accion == "decrementar" && nuevaCantidad > this.min) {
      nuevaCantidad--;
      this.parrafo.textContent = nuevaCantidad;
    }

    this.actualizarBotones();
  }
}

customElements.define("cantidad-input", CantidadInput);

class MensajeTemporal extends HTMLElement {
  // REFERENCIAS ELEMENTOS
  contenedor = null;
  etiquetaMensaje = null;
  iconos = [];
  tiempoEspera = null;

  constructor() {
    super();
  }

  connectedCallback() {
    // Obtenemos referencias a los elementos internos
    this.contenedor = this.querySelector("#ph-mec");
    this.etiquetaMensaje = this.querySelector("#ph-mec-etiqueta-mensaje");
    this.iconos = this.querySelectorAll('[id="ph-mec-icono-"]');

    this.iconos.forEach((icono) => {
      icono.classList.add("elemento-oculto");
    });

    // Verificamos que todos los elementos existan
    if (!this.contenedor || !this.etiquetaMensaje) {
      console.error(
        "No se encontraron todos los elementos necesarios para el componente MensajeTemporal"
      );
    }
  }

  /**
   * Método para mostrar un mensaje
   * @param {string} mensaje - El texto del mensaje a mostrar
   * @param {string} tipo - El tipo de mensaje ('exito', 'error', 'info', 'alerta')
   * @param {number} duracion - Duración en ms que se mostrará el mensaje
   */
  mostrar(mensaje, tipo = "exito", duracion = 3000) {
    // Verificar que las referencias esten disponibles
    if (!this.contenedor || !this.etiquetaMensaje) {
      console.error(
        "No se encontraron todos los elementos necesarios para el componente MensajeTemporal"
      );
      return false;
    }

    // Ocultar todos los iconos
    this.iconos.forEach((icono) => {
      icono.classList.remove("elemento-visible");
      icono.classList.add("elemento-oculto");
    });

    // Mostrar el icono correspondiente al tipo de mensaje
    const iconoActual = this.querySelector(`.ph-mec-icono-${tipo}`);
    if (iconoActual) {
      iconoActual.classList.remove("elemento-oculto");
      iconoActual.classList.add("elemento-visible");
    }

    // Esatblecer el texto del mensaje
    this.etiquetaMensaje.textContent = mensaje;

    // Remove clases de tipo anteriores y aplicar la nueva
    this.contenedor.classList.remove("exito", "error", "info", "alerta");
    this.contenedor.classList.add(tipo);

    // Mostrar el mensaje
    this.contenedor.style.opacity = "1";
    this.contenedor.style.visibility = "visible";

    // Limpiar el timeout nterior si existe
    if (this.tiempoEspera) {
      clearTimeout(this.tiempoEspera);
    }

    // Establecer nuevo tiemout
    this.tiempoEspera = setTimeout(() => {
      this.ocultar();
    }, duracion);
    return true;
  }

  ocultar() {
    if (this.contenedor) {
      this.contenedor.style.opacity = "0";
      this.contenedor.style.visibility = "hidden";
    }

    // Ocultar todos los iconos al cerrar el mensaje
    this.iconos.forEach((icono) => {
      icono.classList.remove("elemento-visible");
      icono.classList.add("elemento-oculto");
    });

    if (this.tiempoEspera) {
      clearTimeout(this.tiempoEspera);
      this.tiempoEspera = null;
    }
  }

  disconnectedCallback() {
    // Limpiamos cualquier timeout pendiente
    if (this.tiempoEspera) {
      clearTimeout(this.tiempoEspera);
      this.tiempoEspera = null;
    }
  }

  /**
   * Método estático para mostrar un mensaje global
   * Encuentra o crea una instancia del componente y muestra el mensaje
   */
  static mostrarMensaje(mensaje, tipo = "exito", duracion = 3000) {
    // Buscar si ya existe una instancia del componente
    let mensajeElement = document.querySelector("mensaje-temporal");

    // Si no existe una instancia, mostrar error
    if (!mensajeElement) {
      console.error("No se encontró el componente mensaje-temporal en el DOM");
      return false;
    }

    // Llamar al método de instancia
    console.log(
      "Mostrando mensaje:",
      mensaje,
      "Tipo:",
      tipo,
      "Duración:",
      duracion
    );
    return mensajeElement.mostrar(mensaje, tipo, duracion);
  }

  /**
   * Método estático para ocultar el mensaje global
   */
  static ocultarMensaje() {
    const mensajeElement = document.querySelector("mensaje-temporal");
    if (mensajeElement) {
      mensajeElement.ocultar();
    }
  }
}

customElements.define("mensaje-temporal", MensajeTemporal);

class MensajeCargaDatos extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Se ejecuta cuando el componente se añade al DOM
    // No necesitamos inicializar nada especial aquí
  }

  /**
   * Método estático para mostrar el mensaje de carga
   * @param {string} mensaje - El mensaje a mostrar durante la carga
   * @param {boolean} bloquearPantalla - Si debe bloquear interacciones con la pantalla (opcional, por defecto true)
   */
  static mostrar(mensaje = "Cargando datos...", bloquearPantalla = true) {
    // Buscar la instancia del componente
    const mensajeCarga = document.querySelector("mensaje-carga-datos");

    if (!mensajeCarga) {
      console.error(
        "No se encontró el componente mensaje-carga-datos en el DOM"
      );
      return false;
    }

    // Obtener el contenedor modal y el elemento para el mensaje
    const containerModal = mensajeCarga.querySelector("#ph-container-modal");
    const mensajeElement = mensajeCarga.querySelector(
      "#ph-mensaje-carga-datos"
    );

    if (!containerModal || !mensajeElement) {
      console.error(
        "No se encontraron los elementos necesarios dentro del componente"
      );
      return false;
    }

    // Establecer el mensaje
    mensajeElement.textContent = mensaje;

    // Mostrar el modal
    containerModal.style.display = "flex";

    // Si debe bloquear la pantalla, añadir clase o estilo apropiado
    if (bloquearPantalla) {
      document.body.style.overflow = "hidden"; // Evita el scroll
      containerModal.style.pointerEvents = "all"; // Captura todos los clicks
    }

    return true;
  }

  /**
   * Método estático para ocultar el mensaje de carga
   * @param {number} retraso - Milisegundos de retraso antes de ocultar (opcional)
   */
  static ocultar(retraso = 0) {
    const ocultar = () => {
      // Buscar la instancia del componente
      const mensajeCarga = document.querySelector("mensaje-carga-datos");

      if (!mensajeCarga) {
        console.error(
          "No se encontró el componente mensaje-carga-datos en el DOM"
        );
        return false;
      }

      // Obtener el contenedor modal
      const containerModal = mensajeCarga.querySelector("#ph-container-modal");

      if (!containerModal) {
        console.error(
          "No se encontró el contenedor modal dentro del componente"
        );
        return false;
      }

      // Ocultar el modal
      containerModal.style.display = "none";

      // Restaurar comportamiento del body
      document.body.style.overflow = "";
      containerModal.style.pointerEvents = "";

      return true;
    };

    // Si hay retraso, usar setTimeout
    if (retraso > 0) {
      setTimeout(ocultar, retraso);
    } else {
      ocultar();
    }
  }
}

customElements.define("mensaje-carga-datos", MensajeCargaDatos);

class SucursalesInformacion extends HTMLElement {
  constructor() {
    super();
    // Datos de ubicaciones de pizzerías (solo sucursales activas)
    this.pizzaLocations = (window.sucursales || []).filter(
      (loc) => loc.estado !== false
    );

    // Obtener ciudades únicas
    this.ciudades = [
      ...new Set(this.pizzaLocations.map((loc) => loc.ciudad || "Santa Cruz")),
    ];

    // Si no hay ciudades, agregar Santa Cruz por defecto
    if (this.ciudades.length === 0) {
      this.ciudades = ["Santa Cruz"];
    }

    // Tipos de servicio
    this.tiposServicio = ["TODOS", "ENVIO A DOMICILIO", "RECOGER EN LOCAL"];

    // Estado actual de selección
    this.ciudadSeleccionada = this.ciudades[0];
    this.servicioSeleccionado = "ENVIO A DOMICILIO"; // Valor por defecto segun el HTML
  }

  connectedCallback() {
    // Inicializar los selectores de ciudad y servicio
    this.initSelectors();

    // Configurar los event listeners para los selectores
    this.setupEventListeners();

    // Actualizar los locales visibles
    this.updateLocalesVisibles();
  }

  // Inicializa los selectores de ciudad y tipo de servicio
  initSelectors() {
    // No modificamos los selectores iniciales, solo capturamos sus valores
    const selectorCiudades = this.querySelector(
      ".ds-info:nth-child(2) .ds-select-info h3"
    );
    if (selectorCiudades) {
      this.ciudadSeleccionada = selectorCiudades.textContent.trim();
    }

    const selectorServicio = this.querySelector(
      ".ds-info:nth-child(3) .ds-select-info h3"
    );
    if (selectorServicio) {
      this.servicioSeleccionado = selectorServicio.textContent.trim();
    }
  }

  // Configura los event listeners
  setupEventListeners() {
    // Event listeners para los selectores
    const selectorCiudad = this.querySelector(
      ".ds-info:nth-child(2) .ds-select-info"
    );
    const selectorServicio = this.querySelector(
      ".ds-info:nth-child(3) .ds-select-info"
    );

    if (selectorCiudad) {
      selectorCiudad.addEventListener("click", () =>
        this.toggleSelectorCiudad()
      );
    }

    if (selectorServicio) {
      selectorServicio.addEventListener("click", () =>
        this.toggleSelectorServicio()
      );
    }
  }

  // Muestra u oculta el selector de ciudades
  toggleSelectorCiudad() {
    const contenedor = this.querySelector(".ds-info:nth-child(2)");
    if (contenedor) {
      // Si ya existe el dropdown, lo eliminamos
      const dropdownExistente = contenedor.querySelector(".ds-dropdown");
      if (dropdownExistente) {
        dropdownExistente.remove();
        return;
      }
    }
  }

  // Muestra u oculta el selector de tipo de servicio
  toggleSelectorServicio() {
    const contenedor = this.querySelector(".ds-info:nth-child(3)");
    if (contenedor) {
      // Si ya existe el dropdown, lo eliminamos
      const dropdownExistente = contenedor.querySelector(".ds-dropdown");
      if (dropdownExistente) {
        dropdownExistente.remove();
        return;
      }
    }
  }

  // Actualiza la ciudad seleccionada
  seleccionarCiudad(ciudad) {
    this.ciudadSeleccionada = ciudad;
    const selectorCiudades = this.querySelector(
      ".ds-info:nth-child(2) .ds-select-info h3"
    );
    if (selectorCiudades) {
      selectorCiudades.textContent = ciudad;
    }
    this.updateLocalesVisibles();
  }

  // Actualiza el tipo de servicio seleccionado
  seleccionarServicio(servicio) {
    this.servicioSeleccionado = servicio;
    const selectorServicio = this.querySelector(
      ".ds-info:nth-child(3) .ds-select-info h3"
    );
    if (selectorServicio) {
      selectorServicio.textContent = servicio;
    }
    this.updateLocalesVisibles();
  }

  // Obtiene los locales filtrados según la selección actual
  getLocalesFiltrados() {
    // Asumimos que todas las sucursales están en Santa Cruz si no se especifica
    let localesFiltrados = this.pizzaLocations;

    // Filtrar por ciudad, si todas las sucursales son de la misma ciudad, no filtramos
    if (this.ciudades.length > 1) {
      localesFiltrados = localesFiltrados.filter(
        (local) => (local.ciudad || "Santa Cruz") === this.ciudadSeleccionada
      );
    }

    // Filtrar por servicio si no es "TODOS"
    if (this.servicioSeleccionado !== "TODOS") {
      const servicioNormalizado =
        this.servicioSeleccionado === "ENVIO A DOMICILIO"
          ? "envio a domicilio"
          : "recoger en local";

      localesFiltrados = localesFiltrados.filter((local) => {
        // Si no existe servicios, descartar
        if (!local.servicios) {
          return false;
        }

        let serviciosArray = local.servicios;

        // Si es string, intentar parsearlo
        if (typeof serviciosArray === "string") {
          try {
            // Primero intentar JSON estándar
            serviciosArray = JSON.parse(serviciosArray);
          } catch (e1) {
            // Si falla, puede ser sintaxis Python ['valor1', 'valor2']
            // Convertir a JSON válido
            try {
              const jsonString = serviciosArray
                .replace(/'/g, '"')  // Convertir comillas simples a dobles
                .trim();
              serviciosArray = JSON.parse(jsonString);
            } catch (e2) {
              console.error("Error parseando servicios:", local.nombre, serviciosArray);
              return false;
            }
          }
        }

        // Verificar que ahora es un array
        if (!Array.isArray(serviciosArray)) {
          console.warn("servicios no es un array para:", local.nombre, serviciosArray);
          return false;
        }

        return serviciosArray.some(
          (serv) => serv.toLowerCase() === servicioNormalizado
        );
      });
    }

    return localesFiltrados;
  }

  // Parseamos el horario para obtener hora de apertura y cierre
  parseHorario(horarioString) {
    if (!horarioString) return { horaApertura: 8, horaCierre: 23 }; // Default

    // Ejemplo: "8:00 a 23:00"
    const partes = horarioString.split(" a ");
    if (partes.length !== 2) return { horaApertura: 8, horaCierre: 23 };

    const horaAperturaStr = partes[0].trim();
    const horaCierreStr = partes[1].trim();

    // Extraer solo la hora (ignorar los minutos)
    const horaApertura = parseInt(horaAperturaStr.split(":")[0]);
    const horaCierre = parseInt(horaCierreStr.split(":")[0]);

    return { horaApertura, horaCierre };
  }

  parseTurnos(turnos) {
    if (!turnos) return [];
    if (Array.isArray(turnos)) return turnos;
    if (typeof turnos === "string") {
      try {
        const parsed = JSON.parse(turnos.replace(/'/g, '"'));
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  getHorarioDelDia(local) {
    const turnos = this.parseTurnos(local.turnos);
    if (!turnos.length) return null;
    const ahora = new Date();
    const diaSemana = ahora.getDay() === 0 ? 7 : ahora.getDay();
    const turnoHoy = turnos.find((t) => t.dias && t.dias.includes(diaSemana));
    if (!turnoHoy) return null;
    const horaApertura = parseInt(turnoHoy.horaInicial.split(":")[0], 10);
    let horaCierre = parseInt(turnoHoy.horaFinal.split(":")[0], 10);
    if (horaCierre === 0) horaCierre = 24;
    return { horaApertura, horaCierre };
  }

  // Verifica si un local está abierto según la hora actual (usa turnos)
  estaLocalAbierto(local) {
    const turnos = this.parseTurnos(local.turnos);
    if (!turnos || turnos.length === 0) return false;
    return GestionSucursales.validarHorarioApertura(turnos);
  }

  // Configura los botones para abrir el mapa
  setupMapButtons() {
    const botonesUbicacion = this.querySelectorAll(".ds-rl-ubicacion");
    const localesFiltrados = this.getLocalesFiltrados();

    botonesUbicacion.forEach((boton, index) => {
      if (index < localesFiltrados.length) {
        const local = localesFiltrados[index];
        boton.addEventListener("click", () => {
          if (local.lat && local.lng) {
            window.open(
              `https://www.google.com/maps/search/?api=1&query=${local.lat},${local.lng}`,
              "_blank"
            );
          }
        });
      }
    });
  }

  // Formatea la hora para mostrar (convierte formato 24h a 12h con AM/PM)
  formatearHora(hora) {
    if (hora < 12) {
      return `${hora}:00 AM`;
    } else if (hora === 12) {
      return `12:00 PM`;
    } else {
      return `${hora - 12}:00 PM`;
    }
  }

  formatearHoraDesdeString(horaStr) {
    if (!horaStr) return "--";
    const partes = horaStr.trim().split(":");
    const h = parseInt(partes[0], 10);
    const m = parseInt(partes[1], 10) || 0;
    if (isNaN(h)) return "--";
    const minStr = m < 10 ? "0" + m : String(m);
    if (h === 0) return `12:${minStr} AM`;
    if (h < 12) return `${h}:${minStr} AM`;
    if (h === 12) return `12:${minStr} PM`;
    return `${h - 12}:${minStr} PM`;
  }

  formatearRangoDias(dias) {
    if (!dias || !dias.length) return "";
    const nombresDiasCortos = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
    const nombres = (dias.slice().sort((a, b) => a - b)).map((d) => nombresDiasCortos[d === 7 ? 0 : d]);
    const unicos = [...new Set(nombres)];
    if (unicos.length === 1) return unicos[0];
    return unicos.join("-");
  }

  formatearTodosLosTurnos(local) {
    const turnos = this.parseTurnos(local.turnos);
    if (!turnos.length) return "Consultar horario";
    return turnos
      .map((t) => {
        const diasStr = this.formatearRangoDias(t.dias);
        const abrir = this.formatearHoraDesdeString(t.horaInicial);
        const cerrar = this.formatearHoraDesdeString(t.horaFinal);
        return `${diasStr} ${abrir} - ${cerrar}`;
      })
      .join(", ");
  }

  parseServicios(servicios) {
    // Si no existe, retornar array vacío
    if (!servicios) {
      return [];
    }

    // Si ya es un array, retornarlo
    if (Array.isArray(servicios)) {
      return servicios;
    }

    // Si es string, intentar parsearlo
    if (typeof servicios === "string") {
      try {
        // Primero intentar JSON estándar
        const parsed = JSON.parse(servicios);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e1) {
        // Si falla, puede ser sintaxis Python ['valor1', 'valor2']
        try {
          const jsonString = servicios
            .replace(/'/g, '"')  // Convertir comillas simples a dobles
            .trim();
          const parsed = JSON.parse(jsonString);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e2) {
          console.error("Error parseando servicios:", servicios, e2);
          return [];
        }
      }
    }

    return [];
  }

  // Actualiza la visualización de locales según los filtros actuales
  updateLocalesVisibles() {
    const contenedorRight = this.querySelector(".ds-contenedor-right");
    if (!contenedorRight) return;

    // Limpiar contenedor
    contenedorRight.innerHTML = "";

    // Obtener locales filtrados
    const localesFiltrados = this.getLocalesFiltrados();

    // Generar HTML para cada local
    localesFiltrados.forEach((local) => {
      const horario = this.getHorarioDelDia(local);
      const estaAbierto = this.estaLocalAbierto(local);
      const claseDisponibilidad = estaAbierto ? "ds-abierto " : "ds-cerrado ";
      const colorTexto = estaAbierto ? " color-extra-2" : " color-extra-1";

      const textoDisponibilidad = estaAbierto ? "ABIERTO" : "CERRADO";

      const horaAperturaFormateada = horario ? this.formatearHora(horario.horaApertura) : "--";
      const horaCierreFormateada = horario ? this.formatearHora(horario.horaCierre === 24 ? 0 : horario.horaCierre) : "--";

      const textoEstadoHoy = horario
        ? estaAbierto
          ? `Abierto hasta las ${horaCierreFormateada}`
          : `Abre a las ${horaAperturaFormateada}`
        : "";

      const textoTodosTurnos = this.formatearTodosLosTurnos(local);
      const lineasTurnos = textoTodosTurnos === "Consultar horario" ? [] : textoTodosTurnos.split(", ");
      const lineasHorario = lineasTurnos;
      const textoHorario = lineasHorario.join("<br>");

      // Parsear servicios antes de usar
      const serviciosArray = this.parseServicios(local.servicios);

      const localHTML = `
        <div class="ds-rl-local">
          <div class="ds-titulos">
            <h3>${local.ciudad || "SANTA CRUZ"}</h3>
            <h3 class="color-letras-primary">${local.nombre}</h3>
          </div>
          <div class="ds-rl-disponibilidad">
            <div class="ds-rl-disponibilidad-info ${claseDisponibilidad}">
              ${window.shopIcons.icon_disponibilidad}
              <p class="${colorTexto}">${textoDisponibilidad}</p>
            </div>
          </div>
          <div class="ds-rl-info-local">
            <div class="ds-rl-info-local-item" data-tipo="direccion" data-lat="${local.lat || ''}" data-lng="${local.lng || ''}" data-direccion="${String(local.localizacion || '').replace(/"/g, '&quot;')}" role="button" tabindex="0" title="Abrir en Google Maps">
              ${window.shopIcons.icon_location_on}
              <p>${local.localizacion}</p>
            </div>
            <div class="ds-rl-info-local-item" data-tipo="telefono" data-telefono="${String(local.telefono || '').replace(/"/g, '&quot;')}" role="button" tabindex="0" title="Abrir en WhatsApp">
              ${window.shopIcons.icon_headser_mic}
              <p>${local.telefono}</p>
            </div>
            <div class="ds-rl-info-local-item">
              ${window.shopIcons.icon_clock}
              <p class="ds-rl-horario-lineas">${textoHorario}</p>
            </div>
            <div class="ds-rl-info-servicios">
              ${serviciosArray
          .map(
            (servicio) => `
                    <div class="ds-rl-info-servicio">
                      ${window.shopIcons.icon_check}
                      <p>${servicio}</p>
                    </div>
                  `
          )
          .join("")}
            </div>
          </div>
          <button class="ds-rl-boton ds-rl-ubicacion">
            <p class="color-letras-primary">Abrir ubicación en mapa</p>
            ${window.shopIcons.icon_map}
          </button>
        </div>
      `;

      // Agregar al contenedor
      contenedorRight.innerHTML += localHTML;
    });
    // Reiniciar event listeners para los botones de mapa
    this.setupMapButtons();
    // Clics en teléfono (WhatsApp) y dirección (Google Maps)
    this.setupInfoItemClicks();
  }

  // Configura clics en items de teléfono (WhatsApp) y dirección (Google Maps)
  setupInfoItemClicks() {
    const contenedorRight = this.querySelector(".ds-contenedor-right");
    if (!contenedorRight) return;

    // Dirección → Google Maps
    contenedorRight.querySelectorAll('.ds-rl-info-local-item[data-tipo="direccion"]').forEach((el) => {
      el.addEventListener("click", () => {
        const lat = el.dataset.lat;
        const lng = el.dataset.lng;
        const dir = (el.dataset.direccion || "").trim();
        if (lat && lng) {
          window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`, "_blank");
        } else if (dir) {
          window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(dir)}`, "_blank");
        }
      });
    });

    // Teléfono → WhatsApp
    contenedorRight.querySelectorAll('.ds-rl-info-local-item[data-tipo="telefono"]').forEach((el) => {
      el.addEventListener("click", () => {
        let tel = (el.dataset.telefono || "").replace(/\D/g, "");
        if (tel) {
          if (!tel.startsWith("591")) tel = "591" + tel;
          window.open(`https://wa.me/${tel}`, "_blank");
        }
      });
    });
  }
}

customElements.define("sucursales-informacion", SucursalesInformacion);

class SearchProducts extends HTMLElement {
  constructor() {
    super();

    this.resultadosBusqueda = [];
    this.categoriasConstruccion = window.categoriasConstruccion;
    this.pizzaLocations = GestionSucursales.corroborarInfoShopify(
      window.sucursales,
      JSON.parse(localStorage.getItem("sucursal-informacion"))
    );
    this.coleccionesProcesadas = null;
    this.productosEncontrados = null;
    this.abortController = null;
  }

  connectedCallback() {
    this.btnExplorarMenu = this.querySelector("#phsp-btn-explorar-menu");
    this.btnExplorarMenu.addEventListener("click", () => {
      window.location.href = "/pages/_menu-1?coleccion=Pizzas";
    });
    this.contenedorItemsResultados = this.querySelector(
      "#phsp-items-productos"
    );
    this.contenedorVacioResultados = this.querySelector(
      "#phsp-items-no-encontrados"
    );
    this.inputBusqueda = this.querySelector("#phsp-input-busqueda");
    this.inputBusqueda.value = localStorage.getItem("ph-busqueda-query") || "";
    this.btnLimpiarInputBusqueda = this.querySelector(
      "#phsp-limpiar-input-busqueda"
    );
    this.btnLimpiarInputBusqueda.addEventListener("click", () => {
      this.inputBusqueda.value = "";
      localStorage.removeItem("ph-busqueda-query");

      this.contenedorItemsResultados.style.display = "none";
      this.contenedorVacioResultados.style.display = "flex";
      this.etiquetaCantidadResultados.textContent = "Sin Resultados(0)";

      this.inputBusqueda.focus();
    });
    this.inputBusqueda.addEventListener(
      "input",
      this.accionEscribeInput.bind(this)
    );

    this.etiquetaCantidadResultados = this.querySelector(
      "#phsp-etiqueta-cantidad-resultados"
    );

    if (this.inputBusqueda.value == "") {
      // Si hay un valor en el input, mostrar resultados de búsqueda
      this.contenedorItemsResultados.style.display = "none";
      this.contenedorVacioResultados.style.display = "flex";
      this.etiquetaCantidadResultados.textContent = "Sin Resultados(0)";
      localStorage.setItem(
        "ph-busqueda-query",
        this.inputBusqueda.value.trim()
      );
    } else {
      // Crear AbortController antes de la primera búsqueda
      this.abortController = new AbortController();
      this.construirResultadosBusqueda();
    }
  }

  async accionEscribeInput() {
    // AGREGAR: Cancelar petición anterior si existe
    if (this.abortController) {
      this.abortController.abort();
    }

    // Aplicar debounce - limpiar el timeout anterior
    clearTimeout(this.debounceTimeout);

    // Crear nuevo timeout de 300ms
    this.debounceTimeout = setTimeout(async () => {
      const inputValue = this.inputBusqueda.value.trim();

      if (inputValue.length == 0) {
        this.contenedorItemsResultados.style.display = "none";
        this.contenedorVacioResultados.style.display = "flex";
        this.etiquetaCantidadResultados.textContent = "Sin Resultados(0)";
        return;
      }

      // AGREGAR: Crear nuevo AbortController para esta búsqueda
      this.abortController = new AbortController();
      await this.construirResultadosBusqueda();
    }, 300);
  }

  async construirResultadosBusqueda() {
    try {
      MensajeCargaDatos.mostrar("Cargando resultados de búsqueda...");

      // Crear AbortController si no existe
      if (!this.abortController) {
        this.abortController = new AbortController();
      }

      // Realizar la búsqueda en Shopify usando GestorProductos
      const respuesta = await GestorProductos.buscarProductosShopify(
        this.inputBusqueda.value,
        this.abortController.signal
      );

      // Si no hay resultados, mostrar mensaje vacío
      if (respuesta.length === 0) {
        this.contenedorItemsResultados.style.display = "none";
        this.contenedorVacioResultados.style.display = "flex";
        this.etiquetaCantidadResultados.textContent = "Sin Resultados(0)";
        MensajeCargaDatos.ocultar();
        return;
      }

      // Mostrar resultados
      this.contenedorItemsResultados.style.display = "grid";
      this.contenedorVacioResultados.style.display = "none";
      this.etiquetaCantidadResultados.textContent = `Resultados(${respuesta.length})`;

      // Crear el HTML con la estructura correcta
      let htmlResultados = "";

      respuesta.forEach((item) => {
        htmlResultados += `
        <div 
          data-titulo="${item.nombre}"
          class="pirb-producto-item">
          <div class="pirb-producto-item-imagen">
            <img
              src="${item.imagen || window.assets.imagen_aux}"
              alt="${item.nombre}"
              width="100%"
              height="100%"
            >
          </div>
          <div class="pirb-producto-item-info">
            <h3>${item.nombre}</h3>
            <h3 class="color-letras-primary">${item.precio} BS</h3>
            <button id="pirb-btn-personalizar" class="boton-producto-personalizar">
              <p class="color-letras-secondary">Personalizar</p>
            </button>
          </div>
        </div>
      `;
      });

      this.contenedorItemsResultados.innerHTML = htmlResultados;

      // Mostrar el contenedor de resultados si no está visible
      if (this.contenedorItemsResultados.style.display !== "grid") {
        this.contenedorItemsResultados.style.display = "grid";
      }

      // Agregar eventos simplificados como el header
      this.btnsItemsPersonalizar = this.querySelectorAll("#pirb-btn-personalizar");

      this.btnsItemsPersonalizar.forEach((boton) => {
        boton.addEventListener("click", async () => {
          const item = boton.closest(".pirb-producto-item");
          const titulo = item.dataset.titulo;

          // Validar que existe el título
          if (!titulo) {
            MensajeTemporal.mostrarMensaje(
              "Error: No se pudo obtener el título del producto",
              "error",
              3000
            );
            return;
          }

          // Usar el mismo método que el header
          await GestorProductos.evaluarDisponibilidadProducto(titulo);
        });
      });

      MensajeCargaDatos.ocultar();
    } catch (error) {
      console.error("Error al procesar la búsqueda:", error);
    }
  }
}

customElements.define("search-products", SearchProducts);

class SeccionPublicitaria extends HTMLElement {
  constructor() {
    super();
    this.imagenElement = null;
    this.mediaQueryDesktop = window.matchMedia('(min-width: 1024px)');
  }

  connectedCallback() {
    this.imagenElement = this.querySelector('#phohci-imagen');

    if (this.imagenElement) {
      // Configurar imagen inicial según dispositivo
      this.actualizarImagenSegunDispositivo();

      // Escuchar cambios en el tamaño de pantalla
      this.mediaQueryDesktop.addEventListener('change', () => {
        this.actualizarImagenSegunDispositivo();
      });

      // Configurar click para redirección
      this.imagenElement.addEventListener('click', this.redireccionarImagen.bind(this));
    }
  }

  actualizarImagenSegunDispositivo() {
    if (!this.imagenElement) return;

    const imagenMobile = this.imagenElement.dataset.imageMobile;
    const imagenDesktop = this.imagenElement.dataset.imageDesktop;

    if (!imagenMobile && !imagenDesktop) return;

    const esDesktop = this.mediaQueryDesktop.matches;
    const nuevaUrl = esDesktop ? imagenDesktop || imagenMobile : imagenMobile || imagenDesktop;

    if (this.imagenElement.src !== nuevaUrl && nuevaUrl) {
      this.imagenElement.style.opacity = '0';

      setTimeout(() => {
        this.imagenElement.src = nuevaUrl;
        this.imagenElement.style.opacity = '1';
      }, 200);
    }
  }

  redireccionarImagen() {
    const tipoProceso = this.imagenElement.dataset.tipoProceso;
    const destinoTexto = this.imagenElement.dataset.destinoTexto;
    console.log(tipoProceso, destinoTexto);

    if (tipoProceso === 'ninguno' || !destinoTexto || destinoTexto.trim() === '') return;

    if (tipoProceso === 'coleccion') {
      window.location.href = `/pages/_menu-1?coleccion=${destinoTexto}`;
      return;
    } else if (tipoProceso === 'producto') {
      window.location.href = '/products/' + destinoTexto;
    } else if (tipoProceso === 'pagina_externa') {
      window.open(destinoTexto, '_blank');
      return;
    }
  }

  disconnectedCallback() {
    this.mediaQueryDesktop.removeEventListener('change', this.actualizarImagenSegunDispositivo);
  }
}

customElements.define('seccion-publicitaria', SeccionPublicitaria);